<div class="wrapper-container">
    <!-- Trend & Parameter Menu -->
    <div class="dropdown-container d-flex align-items-center gap-3">
        <div ngbDropdown #dropdown="ngbDropdown" class="dropdown-panel">
            <button ngbDropdownToggle class="btn btn-outline-primary d-flex align-items-center gap-2">
                <i class="bi bi-sliders"></i> <!-- Bootstrap icon -->
                Filters & Parameters
            </button>

            <div ngbDropdownMenu class="p-3 custom-dropdown-menu">
                <h6 class="dropdown-title mb-2">Select Parameters</h6>
                <div class="parameter-list mb-2">
                    <div class="form-check" *ngFor="let item of parameters">
                        <input type="checkbox" class="form-check-input" [id]="item.label" [(ngModel)]="item.checked" />
                        <label class="form-check-label" [for]="item.label">{{ item.label }}</label>
                    </div>
                </div>

                <hr />

                <h6 class="dropdown-title mb-2">Trends</h6>
                <div class="btn-group d-flex justify-content-between gap-2 mb-2">
                    <button mat-stroked-button color="primary" [ngClass]="{ active: trendsFilter === 'hour' }"
                        (click)="handleTrendsFilter('hour')">
                        Hourly
                    </button>
                    <button mat-stroked-button color="primary" [ngClass]="{ active: trendsFilter === 'day' }"
                        (click)="handleTrendsFilter('day')">
                        Daily
                    </button>
                    <button mat-stroked-button color="primary" [ngClass]="{ active: trendsFilter === 'week' }"
                        (click)="handleTrendsFilter('week')">
                        Weekly
                    </button>
                </div>

                <div class="d-flex justify-content-between align-items-center gap-2 mt-3">
                    <button class="btn btn-sm btn-success flex-fill" (click)="applySelection(dropdown)">
                        <i class="bi bi-check-circle"></i> Apply Selection
                    </button>
                    <button class="btn btn-sm btn-danger" (click)="onCancel()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="chart-loader">
        <div class="spinner"></div>
    </div>

    <div *ngIf="errorMessage" class="no-data-message">
        {{ errorMessage }}
    </div>

    <div class="chart-grid">
        <ng-container *ngFor="let chart of parameters">
            <div *ngIf="chart.checked && chartOptionsMap[chart.key]" class="chart-wrapper">
                <apx-chart [series]="chartOptionsMap[chart.key].series" [chart]="chartOptionsMap[chart.key].chart"
                    [xaxis]="chartOptionsMap[chart.key].xaxis" [dataLabels]="chartOptionsMap[chart.key].dataLabels"
                    [yaxis]="chartOptionsMap[chart.key].yaxis" [colors]="chartOptionsMap[chart.key].colors"
                    [legend]="chartOptionsMap[chart.key].legend" [fill]="chartOptionsMap[chart.key].fill"></apx-chart>
            </div>
        </ng-container>
    </div>



</div>